import { Box, Checkbox, FormControlLabel } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ConfigureControl } from '.';
import { filterConfigurationApiHash } from '../../../../utils/configurationApi';
import TableFilter from '../configurationApiBlock/configurationApiTable/components/TableFilter';

const ConfigureControlWrapper = ({ hashBySource, hash, onHashChange, sport, sources }) => {
  const [filteredHashBySource, setFilteredHashBySource] = useState(hashBySource);

  const filterHashBySource = useCallback((filter) => {
    const newFilteredHashBySource = filterConfigurationApiHash(hashBySource, filter);
    for (let league of Object.values(newFilteredHashBySource)) {
      league.isCollapsed = !!filter;
    }
    setFilteredHashBySource(newFilteredHashBySource);
  }, [hashBySource]);

  const handleToggleCollapse = useCallback((key, value) => {
    const newFilteredHashBySource = { ...filteredHashBySource };
    newFilteredHashBySource[key].isCollapsed = value;
    setFilteredHashBySource(newFilteredHashBySource);
  }, [filteredHashBySource]);

  const allItems = useMemo(() => {
    const items = [];
    for (const league of Object.values(filteredHashBySource)) {
      items.push({
        id: league.id,
        level: 2,
        parentId: null,
        displayOrder: hash?.[`2-${league.id}`]?.displayOrder || '',
        priority: hash?.[`2-${league.id}`]?.priority,
      });
      if (league.children?.length) {
        for (const child of league.children) {
          items.push({
            id: child.id,
            level: 3,
            parentId: league.id,
            displayOrder: hash?.[`3-${child.id}`]?.displayOrder || '',
            priority: hash?.[`3-${child.id}`]?.priority,
          });
        }
      }
    }
    return items;
  }, [filteredHashBySource, hash]);

  const isAllSelected = useMemo(() => {
    if (!allItems.length) return false;
    return allItems.every((it) => !!hash?.[`${it.level}-${it.id}`]);
  }, [allItems, hash]);

  const handleSelectAll = useCallback(() => {
    if (!allItems.length) return;
    onHashChange(allItems, !isAllSelected);
  }, [allItems, isAllSelected, onHashChange]);

  useEffect(() => {
    setFilteredHashBySource(hashBySource);
  }, [hashBySource]);

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
        <Box sx={{ flex: 1, '& .MuiTextField-root': { width: '100%' } }}>
          <TableFilter delay={300} onChange={(value) => filterHashBySource(value)} />
        </Box>
        <FormControlLabel
          label="Select all"
          control={
            <Checkbox
              checked={isAllSelected}
              disabled={!allItems.length}
              onChange={handleSelectAll}
            />
          }
        />
      </Box>
      {Object.values(filteredHashBySource).map((item) => <ConfigureControl
        key={item.id}
        item={item}
        hash={hash}
        level={2}
        onHashChange={onHashChange}
        parentId={null}
        sport={sport}
        sources={sources}
        toggleCollaps={(value) => handleToggleCollapse(item.id, value)}
      />)}
    </Box>
  );
}

export default ConfigureControlWrapper;
